export default {
    fund: [{
            "title": "有限合伙型股权投资基金的投资者人数上限为（　　）。",
            "question": "A．100人\nB．20人\nC．200人\nD． 50人",
            "answer": "D",
            "explain": "有限合伙型股权投资基金的投资者人数上限为50人。"
        },
        {
            "title": "通常情况下，设置第一拒绝权条款，将会形成的客观影响为（　　）。",
            "question": "A．使外部投资者购买股份成为不可能\nB．降低了外部投资者购买股权的难度\nC．外部投资者对公司增资受到重大影响\nD． 增加了外部投资者购买股权的难度",
            "answer": "D",
            "explain": "第一拒绝权是指目标公司的其他股东欲对外出售股权时，作为老股东的股权投资基金在同等条件下有优先购买权。优先认购权和第一拒绝权是最为常见的股东权利。故“通常情况下，设置第一拒绝权条款，将会形成的客观影响为增加了外部投资者购买股权的难度”。"
        },
        {
            "title": "根据《企业所得税法实施条例》，创业投资企业采取股权投资方式投资于未上市的中小高新技术企业2年以上的，可以按照其（　　）的70%在股权持有满2年的当年，抵扣该创业投资企业的应纳税所得额。",
            "question": "A．净资产\nB．总资产\nC．投资额\nD． 净利润",
            "answer": "C",
            "explain": "《企业所得税法实施条例》第九十七条规定，创业投资企业采取股权投资方式投资于未上市的中小高新技术企业2年以上的，可以按照其投资额的70%在股权持有满2年的当年，抵扣该创业投资企业的应纳税所得额。"
        },
        {
            "title": "关于政府引导基金对创业投资基金的支持方式是（　　）。",
            "questions": "I．可通过出台优惠的税收政策支持创业投资基金<br>II．可认购创业投资基金份额为其提供资金<br>III．可为创业投资基金的融资提供担保服务<br>IV．可对创业投资基金所投企业进行投资支持",
            "question": "A．I、II、III\nB．I、II、IV\nC．II、III、IV\nD． I、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于施售权条款，以下表述正确的是（　　）。",
            "question": "A．施售权是指基金在接受第三方股权收购要约后，有权要求其他股东按照基金与第三方协商确定的出售条件和价格，一起向第三方转让股权\nB．拖售权是指目标公司的其他股东欲对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件要求参与该出售交易\nC．拖售权条款通常与第一拒绝权条款同时出现\nD． 相比施售权，随售权赋予股权投资基金更大的权利，使其即使作为少数股东也可以享有大股东才有的决定公司转让的权利，更有助于退出",
            "answer": "A",
            "explain": "随售权又称共同出售权，是指目标公司的其他股东欲对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。故“拖售权是指目标公司的其他股东敌对外出售股权时，股权投资基金有权其持股比例为基础，以同等条件要求参与该出售交易”错"
        },
        {
            "title": "杠杆收购的收购资金主要来源（　　）。",
            "questions": "I．普通股<br>II．优先股<br>III．垃圾债券<br>IV．银行贷款",
            "question": "A．II、III、IV\nB．I、II、III\nC．I、II、III、IV\nD． I、II、IV",
            "answer": "C",
            "explain": "杠杆收购的收购资金主要有三个来源：第一，普通股，由收购方提供资金。第二，夹层资本，一般采取优先股和垃圾债券的形式，有时附有转股权。第三，高级债，即银行提供的并购贷款。"
        }, {
            "title": "股权投资基金管理人违反《私募投资基金信息披露管理办法》时，中国证券投资基金业协会可采取的自律管理措施有（　　）。",
            "questions": "I．撤销基金管理人登记<br>II．要求信息披露义务人参加强制培训<br>III．取消直接负责的主管人员的基金从业资格<br>IV．情节严重的，移交中国证监会处理",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II、III、IV\nD． I、II、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于合伙型股权投资基金的入伙，以下表述正确的是（　　）。",
            "questions": "I．合伙型股权投资基金具有较强的人合性特征，新合伙人入伙，必须经全体投资者同意<br>II．除合伙协议另有约定外，新合伙人与原有合伙人享受同等权益，承担同等责任<br>III．新合伙人对入伙前合伙企业的债务无需承担责任<br>IV．新合伙人对入伙前合伙企业的债务承担无限连带责任",
            "question": "A．II、III\nB．II\nC．I、II、IV\nD． I、II、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "基金管理人同时管理多只股权投资基金时，应建立防范利益输送和利益冲突机制进行管理的情形是（　　）。",
            "questions": "I．禁用同一外部审计机构<br>II．禁用同一托管人<br>III．将不同基金的账户开设在同一商业银行<br>IV．在不同时点将不同基金的资金投资于同一被投资企业",
            "question": "A．IV\nB．I、II、III\nC．I、II、IV\nD． I、II",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于股权投资母基金，以下表述正确的是（　　）。",
            "question": "A．主要投资政府引导基金\nB．不能直接投资企业股权\nC．主要投资股权投资基金\nD． 主要投资企业股权",
            "answer": "C",
            "explain": "业务内容主要包括一级投资、二级投资和直接投资。一级投资，是指母基金在股权投资基金募集时对基金进行投资，成为基金投资者。母基金发展初期，主要从事一级投资业务，一级投资是母基金的本源业务。二级投资，是指母基金在股权投资基金募集设立完成后，对存续基金或其投资的组合公司进行投资，直接投资，是指母基金直接对非公开发行和交易的企业股权进行投资。故“股权投资母基金主要投资于股权投资基金”。"
        },
        {
            "title": "股权投资基金管理人及其从业人员违反法律、法规、规章的规定，中国证监会及其派出机构可以对其采取下列行政处罚（　　）。",
            "questions": "I．撤销基金从业资格<br>II．没收违法所得<br>III．公开谴责<br>IV．罚款",
            "question": "A．I、II\nB．I、II、III、IV\nC．I、II、IV\nD． III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "合伙型股权投资基金的所得税缴纳需遵循的原则是（　　）。",
            "question": "A．“先分后税”原则\nB．“免税”原则\nC．“减税”原则\nD． “先税后分”原则",
            "answer": "A",
            "explain": "根据《合伙企业法》等相关规定，合伙企业生产经营所得和其他所得采取“先分后税”的原则：合伙企业以每一个合伙人为纳税义务人，合伙企业层面不缴纳所得税。合伙企业合伙人是自然人的，缴纳个人所得税；合伙人是法人和其他组织的，缴纳企业所得税。"
        }, {
            "title": "关于股权投资基金的清算退出流程，以下表述错误的是（　　）。",
            "question": "A．基金存续期限届满且公司或全体合伙人决定不再经营的，应当安排清算\nB．清算过程中的剩余财产应该先支付税费然后向投资人分配\nC．所有投资项目都实现到期退出的，应当安排基金清算\nD． 无论是公司型、合伙型、还是信托（契约）型股权投资基金，都应该及时向工商机关办理注销手续",
            "answer": "D",
            "explain": "不同于公司型及合伙型股权投资基金，信托（契约）型股权投资基金无须在工商行政管理机关办理工商登记手续。故“无论是公司型、合伙型、还是信托（契约）型股权投资基金，都应该及时向工商机关办理注销手续”错误。"
        },
        {
            "title": "天使投资个人在试点地区投资多个初创科技型企业，对其中办理注销清算的初创科技型企业，天使投资个人对其投资额的（　　）尚未抵扣完的，可自注销清算之日起36个月抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额。",
            "question": "A．0.6\nB．0.9\nC．0.7\nD． 0.5",
            "answer": "C",
            "explain": "天使投资个人在试点地区投资多个初创科技型企业的，对其中办理注销清算的初创科技型企业，天使投资个人对其投资额的70%尚未抵扣完的，可自注销清算之日起36个月内抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额。"
        },
        {
            "title": "创业投资基金的投资范围包括（　　）。",
            "questions": "I．初创阶段的科技企业<br>II．未上市的成长性企业<br>III．全国中小企业股份转让系统挂牌企业<br>IV．创业板上市公司",
            "question": "A．I\nB．I、II、III、IV\nC．I、II、III\nD． I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于基金清算，以下表述错误的是（　　）。",
            "question": "A．基金投资人按照基金合同约定的程序对基金是否清算事项作出决议，且同意清算的表决权达到约定比例时，基金应当清算\nB．一般地，基金合同约定的存续期届满时应进行清算\nC．基金投资的项目没有全部退出时可以进行清算\nD． 基金清算是指基金定期或不定期对其资产、负债、权益等情况进行核算",
            "answer": "D",
            "explain": "股权投资基金的清算，是指在基金存续期限面临终止的情况下，负有清算义务的主体，按照法律法规规定和基金合同约定的方式、程序对基金的资产、负债、权益等进行全面的清理和处置的行为。故“基金清算是指基金定期或不定期对其资产、负债、权益等情况进行核算”错误。"
        },
        {
            "title": "杠杆收购基金用少量的自有资金结合大规模的外部资金来收购目标企业，影响杠杆收购基金的自有资金和外部资金比例的因素，不包括（　　）。",
            "question": "A．资本结构的风险\nB．目标企业的股权结构\nC．目标企业所能产生的现金流\nD． 外部资金的融资成本",
            "answer": "B",
            "explain": "杠杆收购是指收购方用少量的自有资金结合大规模的外部资金来收购目标企业的活动。收购方的自有资金和外部资金的比例，通常取决于以下三个因素：第一，目标公司所能产生的现金流。第二，外部资金的融资成本。第三，资本结构的风险。故“影响杠杆收购基金的自有资金和外部资金比例的因素不包括目标企业的股权结构”。"
        },
        {
            "title": "股权投资基金管理人收入不包括（　　）。",
            "question": "A．业绩报酬\nB．管理费\nC．追赶收益\nD． 门槛收益",
            "answer": "D",
            "explain": "基金的费用类型之一就是基金管理人的管理费。故“股权投资基金管理人收入包括管理费”。从收益分配的基本概念来看，业绩报酬是指基金管理人在为基金创造了超额收益后，参与到基金的收益分配中来，按照约定的比例提取已经实现的基金收益，作为对基金管理人创造超额收益的奖励。故“股权投资基金管理人收入包括业绩报酬”。在设置了门槛收益率条款的股权投资基金里，向全体基金投资者返还投资本金后，还应继续向基金投资者进行分配，直至投资者获得按照门槛收益率计算的投资回报（门槛收益）之后，才开始向基金管理人分配业绩报酬。故“股权投资基金管理人收入不包括门槛收益”。追赶机制是指在向基金投资者分配投资本金及门槛收益之后，将剩余收益先行向基金管理人分配，直至达到门槛收益与当前“追赶”金额之和的既定比例，作为基金管理人的业绩报酬。故“股权投资基金管理人收入包括追赶收益”。"
        }, {
            "title": "以下表述不属于股权投资基金信息披露禁止性行为的是（　　）。",
            "question": "A．委托第三方机构代为披露\nB．登载投资者的祝贺性文字\nC．公开披露\nD． 存在重大遗漏",
            "answer": "A",
            "explain": "信息披露义务人披露基金信息，不得存在以下行为：（1）公开披露或者变相公开披露；（2）虚假记载、误导性陈述或者重大遗漏；（3）对投资业绩进行预测；（4）违规承诺收益或者承担损失；（5）诋毁其他基金管理人、基金托管人或者基金销售机构；（6）登载任何自然人、法人或者其他组织的祝贺性、恭维性或推荐性文字；（7）采用不具有可比性、公平性、准确性、权威性的数据来源和方法进行业绩比较，任意使用“业绩最佳”“规模最大”等相关措辞；"
        },
        {
            "title": "在杠杆收购基金的融资渠道中，夹层资本相比于银行贷款（　　）。",
            "question": "A．优先级低，成本高\nB．优先级高，成本低\nC．优先级高，成本高\nD． 优先级低，成本低",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "股权投资基金拟对某投资项目采用清算退出方式退出，以下表述错误的是（　　）。",
            "question": "A．股权投资基金选择对该项目的投资一般被认定为投资失败\nB．股权投资基金对剩余财产的分配权劣后于公司债权人\nC．无论采用何种清算方式，股权投资基金不能成为清算组的成员\nD． 股权投资基金选择对该项目清算退出，通常是为了降低损失",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "某股权投资基金与A公司签署的投资框架协议中有排他性条款，以下行为不违反排他性条款的是（　　）。",
            "question": "A．A公司的财务负责人与某银行接触商讨银行贷款协议\nB．A公司聘请的财务顾问将A公司商业计划书发送给某投资机构\nC．A公司的股东与某投资人探讨A公司的本次股权融资方案\nD． A公司的法务与某投资机构谈判签署投资框架协议",
            "answer": "A",
            "explain": "排他性条款通常是投资框架协议中的条款，它要求目标公司现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。故“不违反排他性条款的是A公司的财务负责人与某银行接触商讨银行贷款协议”。"
        },
        {
            "title": "某股权投资基金为A公司股东，拥有优先认购权，以下属于基金可行使优先认购权情形的是（　　）。",
            "questions": "I．新发行的股份<br>II．新发行的可转债<br>III．首次公开发行（IPO）的股权<br>IV．为员工持股计划而增发的股份",
            "question": "A．I、II、III\nB．II、III、IV\nC．I、II\nD． I、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "有限合伙型股权投资基金相比于公司型股权投资基金，优点是（　　）。",
            "question": "A．股份有限公司型基金的投资者人数上限多于有限合伙型基金人数上限\nB．有限合伙型股权投资基金有利于借款筹集资金\nC．有限合伙型股权投资基金有利于自然人投资者避免双重纳税\nD． 有限合伙型股权投资基金的投资者以出资额为限承担有限责任",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于投资后管理中的增值服务，以下表述正确的是（　　）。",
            "question": "A．协助被投资企业进行后续再融资，主要是为了便于投资机构获得参与后续轮次融资的机会\nB．对于发展较为成熟的被投资企业，增值服务侧重在规范管理、业务开拓、后续再融资等方面\nC．通过提升被投资企业的价值，降低投资风险，有助于实现投资机构对被投资项目的顺利退出\nD． 对于早期阶段的被投资企业，增值服务侧重在资源导入、兼并收购、上市推动等方面",
            "answer": "C",
            "explain": "在当前市场环境下，增值服务能力甚至成为投资机构的核心竞争力。一方面，通过增值服务能协助被投资企业实现更好更快的发展；另一方面，可以有效地降低投资风险。同时，良好的增值服务能够增加投资机构品牌内涵和价值，成为投资机构“软实力”的重要体现。对于处在不同成长阶段的被投资企业，投资机构对其在投资后管理中参与的程度与侧重点也有所不同。对于早期阶段的被投资企业，投资机构"
        },
        {
            "title": "在已投企业未来增加发行股份时，股权投资基金可通过（　　）保护其股权比例不被稀释。",
            "question": "A．优先认购权条款\nB．排他性条款\nC．反摊薄条款\nD． 保护性条款",
            "answer": "A",
            "explain": "优先认购权使股权投资基金可以在未来公司增加发行股份时，保护其股权比例不被稀释。"
        }, {
            "title": "股权投资基金在进行业务尽职调查时，关于管理团队调查的关注内容，通常不包括（　　）。",
            "question": "A．董事会成员履历\nB．薪酬体系与期权/股权激励机制\nC．公司年度招聘计划\nD． 管理团队履历",
            "answer": "C",
            "explain": "业务尽职调查包括：企业基本情况、管理团队、市场等。其中管理团队包括：董事会成员及主要高级管理人员的履历介绍、薪酬体系、期权或股权激励机制等。"
        },
        {
            "title": "除中国证监会外，其他相关政府部门也在各自职责范围内行使对股权投资基金的管理职权，以下表述错误的是（　　）。",
            "question": "A．外交部负责跨境股权投资基金的监管工作\nB．工商行政管理部门负责股权投资基金的工商登记工作\nC．财政部和国家发展改革委负责政府投资基金的管理和规范工作\nD． 财政部和国家税务总局负责股权投资基金的税收管理工作",
            "answer": "A",
            "explain": "除中国证监会作为股权投资基金法定监管机构外，其他相关政府部门和司法机关也在各自职责范围内行使对股权投资基金的管理职权。例如，工商行政管理部门承担公司型和合伙型股权投资基金的工商登记职责，财政部和国家发展改革委负责政府投资基金的管理和规范工作，商务部和国家外汇管理局对跨境股权投资基金活动承担相应监管职责，财政部和国家税务总局负责股权投资基金相关的税收政策管理，国务院"
        },
        {
            "title": "基金服务机构开展基金服务业务之前，必须具备的条件是（　　）。",
            "question": "A．在中国证券投资基金业协会取得基金服务业务的审批资格\nB．在中国证监会取得基金服务业务的审批资格\nC．在中国证监会进行登记\nD． 在中国证券投资基金业协会进行登记",
            "answer": "D",
            "explain": "股权投资基金管理人应当委托在基金业协会完成登记并已成为基金业协会会员的服务机构提供基金服务业务。"
        },
        {
            "title": "股权投资基金与目标公司签订投资协议时，有关保密条款的表述正确的是（　　）。",
            "question": "A．保密条款意味着投资人不得披露目标公司的任何信息\nB．保密条款有时效性，通常为两个月\nC．保密条款主要约定股权投资基金对目标公司负有保密义务\nD． 对于股权投资基金而言，其所投目标公司组合也属于商业秘密",
            "answer": "D",
            "explain": "保密条款是指除依法律或监管机构要求的信息披露外，投融资双方对在股权投资交易中知悉的对方商业秘密承担保密义务，未经对方书面同意，不得向第三方泄露。保密义务是双方共同的义务。对目标公司而言，其在融资过程中所知悉的股权投资基金的非公开的尽职调查方法与"
        },
        {
            "title": "股权投资基金管理人应当禁止的经营范围不包括（　　）。",
            "question": "A．投资管理、P2P业务\nB．受托股权管理、创业管理\nC．资产管理、为企业提供融资性担保\nD． 投资管理、财务筹划",
            "answer": "B",
            "explain": "对于兼营民间借贷、民间融资、配资业务、小额理财、小额借贷、P2P/P2B、众筹、保理、担保、房地产开发、交易平台等业务的申请机构，由于这些业务与私募基金的属性相冲突，容易误导投资者，为防范风险，基金业协会对从事与私募基金业务相冲突业务的上述机构将不予登记。故“股权投资基金管理人应当禁止的经营范围不包括受托股权管理、创业管理”。"
        },
        {
            "title": "财务尽职调查中的财务比率分析主要包括（　　）。",
            "questions": "I．盈利能力分析<br>II．偿债能力分析<br>III．运营能力分析<br>IV．纳税分析",
            "question": "A．I、II\nB．I、II、III\nC．II、III、IV\nD． I、II、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "以下投资行为属于天使投资的是（　　）。",
            "question": "A．某互联网公司老板使用自有资金投资名下创新环保企业\nB．某互联网公司老板使用自有资金投资其名下公司的附属企业\nC．某互联网公司老板使用自有资金投资某创新环保企业\nD． 某互联网公司老板使用自有资金投资基股权投资基金，并通过该股权投资基金投资基创新环保企业",
            "answer": "C",
            "explain": "天使投资是指除被投资企业职员及家庭关系成员和直系亲属以外的个人以其自有资金直接开展的创业投资活动，属于非组织化创业投资范畴。故“某互联网公司老板使用自有资金投资某创新环保企业”属于天使投资。"
        },
        {
            "title": "关于股权投资募集过程中的责任和义务，表述错误的是（　　）。",
            "question": "A．募集机构应建立相关制度保障投资者的商业秘密\nB．募集机构应与投资者关于基金合同进行充分沟通\nC．基金管理人只有在募集成功后，才需要对投资者投资基金的资金与财产安全承担责任和义务\nD． 无论是自行募集还是委托募集，募集机构都应保证募集行为的合法合规性",
            "answer": "C",
            "explain": "从募集阶段开始就需要对基金投资者投向基金的资金与财产安全承担责任与义务。"
        },
        {
            "title": "私募投资基金管理人内部环境因素包括（　　）。",
            "questions": "I．经营理念和内控文化<br>II．股权结构<br>III．组织结构<br>IV．人力资源政策<br>V．员工道德素质",
            "question": "A．I、II、III、IV、V\nB．I、II、III、IV\nC．II、III、IV、V\nD． I、III、IV、V",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "增值服务处于投资后管理的重要地位，关于增值服务，以下表述正确的是（　　）。",
            "question": "A．投资机构协助被投资企业进行后续再融资工作，以便投资机构能参与被投资企业的公司治理\nB．对于发展较为成熟的被投资企业，增值服务侧重在规范管理、业务拓展、后续再融资等方面\nC．主要目的是，提升被投资企业的价值，降低投资风险，最终实现投资机构对投资项目的顺利退出\nD． 对于早期阶段的被投资企业，增值服务侧重在资源导入、兼并收购、上市推动等方面",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "股权投资基金通常会要求被投资企业与其（　　）签订竞业禁止协议。",
            "questions": "I．创始人<br>II．高级管理人员<br>III．核心技术人员<br>IV．监事",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II、III\nD． II、III",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "股权投资基金要求目标公司通过保密协议或其他方式，确保其董事、高管和其他关键员工不得兼职与本公司业务有关竞争的职位，以上内容属于投资协议的哪一项条款（　　）。",
            "question": "A．排他性条款\nB．保护性条款\nC．保密条款\nD． 竞业禁止条款",
            "answer": "D",
            "explain": "竞业禁止条款是指在投资协议中，股权投资基金为了确保目标公司的良好发展和利益，要求目标公司通过保密协议或其他方式，确保其董事或其他高管不得兼职与本公司业务有竞争的职位，同时，在离职后一段时期内，不得加入与本公司有竞争关系的公司或从事与本公司有竞争"
        }, {
            "title": "在《上市公司创业投资基金股东减持股份的特别规定》中，所称的早期中小企业，是指创业投资基金首次投资该企业时，该企业符合下列条件（　　）。",
            "questions": "I．成立不满60个月<br>II．职工人数不超过500人<br>III．年销售额不超过2亿元<br>IV．资产总额不超过3亿元",
            "question": "A．I、II、III\nB．II、III、IV\nC．I、II、IV\nD． I、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于反摊薄约定的加权平均条款，以下表述错误的是（　　）。",
            "question": "A．加权平均条款与完全棘轮条款相比，在实际谈判中更容易被公司创始股东及投资人各方接受\nB．加权平均条款相对于完全棘轮条款而言，考虑的是融资额度而非价格对比\nC．加权平均条款在该判中对目标公司和创始股东更有利\nD． 加权平均条款在实际操作中，将按照新发行股份价格及数量重新计算反稀释补偿调整后的每股新价格",
            "answer": "B",
            "explain": "与完全棘轮条款不同，加权平均条款将新增出资额的数量作为反稀释时一个重要的考虑因素，既考虑新增出资额的价格，也考虑融资额度。与完全棘轮条款相比，加权平均条款对目标公司和创始股东更为有利，也更容易被各方接受。"
        },
        {
            "title": "小李为合格投资人，同时收到A基金销售机构和B投资顾问机构的募集说明书，原来两家机构同时受M基金管理人委托募集一只股权投资基金。小李在募集说明书中看到，两家机构将分别独立承担因募集行为产生的全部责任，M基金管理人不对募集行为承担任何责任。关于M基金管理人的行为，表述正确的是（　　）。",
            "question": "A．M基金管理人可以同时委托A基金销售机构和B投资顾问机构进行基金募集，但不能豁免承担相关责任\nB．M基金管理人可以同时委托A基金销售机构和B投资顾问机构进行基金募集，且因有约定可豁免承担相关责任\nC．M基金管理人只可以委托A基金销售机构进行基金募集，但不能豁免承担相关责任\nD． M基金管理人只可以委托B投资顾问机构进行基金募集，且因有约定可豁免承担相关责任",
            "answer": "A",
            "explain": "在中国证监会注册取得基金销售业务资格并已成为基金业协会会员的机构（基金销售机构），可以受股权投资基金管理人的委托募集股权投资基金。但是，委托募集并不能豁免基金管理人依法应承担的责任。"
        },
        {
            "title": "采用相对估值法，市盈率等于（　　）。",
            "question": "A．股权价值与净利润的比值\nB．股权价值与税息折旧摊销前收益的比值\nC．股权价值与股东权益账面价值的比值\nD． 股权价值与年销售收入的比值",
            "answer": "A",
            "explain": "市盈率倍数的计算公式为市盈率倍数=股权价值/净利润"
        },
        {
            "title": "关于排他性条款，以下表述错误的是（　　）。",
            "question": "A．排他性条款是投资框架协议和投资协议中常见条款之一\nB．排他期在目标公司收到投资方决定不再执行投资计划的通知时立即结束，因此排他期存在提前结束的可能性\nC．受排他期条款限制的不限于目标公司的股东，还包括其员工、董事、财务顾问、经纪人等\nD． 排他期可以由双方约定，通常为几个月",
            "answer": "A",
            "explain": "本题考查的排他性条款的概念。排他性条款通常是投资框架协议中的条款，它要求目标公司现任股东及其任职职员、董事、财务顾问"
        },
        {
            "title": "关于我国股权投资基金的募集与设立，表述错误的是（　　）。",
            "question": "A．基金管理人可以委托有资质的第三方募集机构募集\nB．基金可选择采用公司、有限合伙或信托（契约）这三种组织形式\nC．基金管理人只能向合格投资者募集\nD． 基金管理人可以以公开方式募集基金",
            "answer": "D",
            "explain": "在国际市场上，股权投资基金既有以非公开方式募集（私募）的，也有以公开方式募集（公募）的。在我国，目前股权投资基金尚只能以非公开方式募集。"
        },
        {
            "title": "关于股权投资基金宣传推介材料，以下表述正确的是（　　）。",
            "question": "A．推介材料登载的管理人管理的其他股权投资基金的过往业绩可以只是部分不连续的业绩\nB．推介材料登载的管理人管理的其他股权投资基金的过往业绩表示对该只基金的业绩构成保证\nC．推介材料登载基金过往业绩的，应当特别声明基金的过往业绩不预示其未来的业绩\nD． 推介材料不能登载基金过往业绩",
            "answer": "C",
            "explain": ""
        }, {
            "title": "股权投资基金常用的估值方法包括（　　）。",
            "questions": "I．重置成本法<br>II．近期交易价格法<br>III．乘数法<br>IV．贝叶斯估值法",
            "question": "A．II、III\nB．I、II、III、IV\nC．I、III\nD． I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于股权投资基金销售服务机构的业务，以下表述正确的是（　　）。",
            "question": "A．可以自行募集其设立的股权投资基金\nB．可以委托其他基金销售机构募集股权投资基金\nC．可以委托基金管理人募集股权投资基金\nD． 可以接受基金管理人委托募集股权投资基金",
            "answer": "D",
            "explain": "股权投资基金的募集，可以分为自行募集和委托募集。自行募集是指基金管理人直接募集其管理的基金，委托募集是指基金管理人委托第三方机构代为募集基金。受托募集的第三方机构就是基金销售机构，为基金管理人提供推介基金、发售基金份额、办理基金份额认缴、退出等募集服务。"
        },
        {
            "title": "为引导私募投资基金专业化估值，保护基金持有人的利益，中国证券投资基金业协会发布了《私募投资基金非上市股权投资估值指引（试行）》，自2018年7月1日起施行。关于私募股权投资基金估值，下列表述正确的是（　　）。",
            "question": "A．对于股权投资基金资产的估值，是先根据投资成本确定基金投资的项目价值，加上基金持有的其他资产价值，再扣减基金应承担的费用等负债，最终得到基金资产净值\nB．如果特估值的投资项目的交易是近期发生的，其成本就很好地反映了公允价值，因此可以使用该交易成本进行估值\nC．对于股权投资基金资产的估值，通常使用的方法主要有三类，即成本法、市场法和乘数法\nD． 对于股权投资基金资产的估值原则和方法，一经使用不得更改",
            "answer": "B",
            "explain": "目前行业较为常用的对股权投资基金进行估值的方式，是先根据估值方法确定基金投资的每一个单一投资项目的价值及项目价值总和，加上基金持有的其他资产价值，再扣减基金应承担的费用等负债，最终得到基金资产净值。故“对于股权投资基金资产的估值，是先根据投资"
        },
        {
            "title": "股权投资基金运行期间，基金管理人应当在5个工作日内向中国证券投资基金业协会报告的重大事项包括（　　）。",
            "questions": "I．投资者数量变化<br>II．主要投资方向变化<br>III．基金期满发生清盘<br>IV．基金托管人变更",
            "question": "A．I、II\nB．III、IV\nC．II、IV\nD． I、III",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "合伙型股权投资基金的合伙协议中，必备内容包括（　　）。",
            "questions": "I．合伙企业的名称和主要经营场所的地点<br>II．发起人认购的份额数、出资方式和出资时间<br>III．合伙企业的解散与清算<br>IV．争议解决办法",
            "question": "A．I、II、III\nB．I、III、IV\nC．I、II\nD． II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "股权投资基金信息披露义务人包括（　　）。",
            "questions": "I．基金托管人<br>II．基金管理人<br>III．基金出资人<br>IV．基金法律顾问",
            "question": "A．I、II\nB．I、II、III、IV\nC．I、II、III\nD． II、III",
            "answer": "A",
            "explain": ""
        }, {
            "title": "关于股权投资基金管理人的职责，以下说法错误的是（　　）。",
            "question": "A．募集股权投资基金前，应获得中国证券投资基金业协会行政审批\nB．为被投企业提供企业战略规划、企业治理水平提升等增值服务\nC．定期向基金投资者量报基金财务报告\nD． 严格按照基金投资策略进行投资运作，并对被投企业进行投后管理",
            "answer": "A",
            "explain": "基金管理人主要履行下列职责：拟订和实施投资方案，并对被投资企业进行投资后管理；积极参与制定被投资企业发展战略，为被投资企业提供增值服务；定期或者不定期向基金投资者披露基金经营运作等方面的信息；定期编制并向基金投资者呈报基金的财务报告。一般来说。"
        },
        {
            "title": "关于股权投资基金的收益分配，以下表述错误的是（　　）。",
            "question": "A．基金管理人的收入分配包括管理费\nB．基金投资者的收入分配包括本金\nC．基金管理人在实现门槛收益率（若有）后才可以获得业绩报酬\nD． 基金管理人的收入分配包括业绩报酬",
            "answer": "A",
            "explain": "基金管理费作为基金在运作中产生的费用，由基金资产承担，不属于基金收益分配的项目。"
        },
        {
            "title": "关于清算退出的表述错误的是（　　）。",
            "question": "A．公司经营管理发生严重困难，继续存续会使股东利益受到重大损失，通过其他选择不能解决时，持有公司全部股东表决权百分之十以上的股东请求法院解散并获法院支持的，应当进行解散清算\nB．清算退出包括解散清算和破产清算\nC．有限责任公司的清算组由董事会或股东大会确定的人员或由股东组成\nD． 破产清算是指公司不能清偿到期债务，并且资产不足以清偿全部债务或者明显缺乏清偿能力时，公司被法院宣告破产，并由法院指定的清算组进行的清算",
            "answer": "C",
            "explain": "公司解散清算的，有限责任公司的清算组由股东组成。"
        },
        {
            "title": "股权投资基金采取股份有限公司形式，投资者人数可为（　　）。",
            "question": "A．2-200人\nB．1-100人\nC．2-50人\nD． 1-50人",
            "answer": "A",
            "explain": "对于公司型基金，以有限责任公司形式设立的，股东人数应在50人以下，以股份有限公司形式设立的，股东人数不超过200人，且应当有2个以上发起人，其中须半数以上的发起人在中国境内有住所。"
        },
        {
            "title": "A股权投资基金持有甲公司500万股，持股比例为10%，现甲公司计划增发1000万股，A基金具有优先认购权，则在同等条件下，A基金可以优先认购的股数为（）万股。",
            "question": "A．50\nB．500\nC．100\nD．200",
            "answer": "C",
            "explain": "优先认购权，是指目标公司未来发行新的股份或者可转换债券时，股权投资基金将按其持股比例获得同等条件下的优先认购权利。A股权投资基金的持股比例为10%，因而在甲公司增发1000万股时可优先认购的股数为100万股。"
        },
        {
            "title": "某股权投资基金甲计划于2018年初对某初创期科技企业A投资500万元。预计2022年底退出对A公司的投资，预计退出时A公司的股权价值为1亿元。根据对A公司尽职调查的结果，股权投资基金甲希望对A公司的投资能实现年化50%的预期投资收益率。使用创业投资估值法，A公司的投资前价值最接近（）。",
            "question": "A．1317万元\nB．1976万元\nC．817万元\nD．1476万元",
            "answer": "A",
            "explain": "设企业当前估值为X，则X（1+50%）^5=1亿，则A公司投资前估值最接近1317万元。"
        },
        {
            "title": "股权投资基金采取股份有限公司形式，投资者人数可为（）。",
            "question": "A．2-200人\nB．1-100人\nC．2-50人\nD．1-50人",
            "answer": "A",
            "explain": "对于公司型基金，以有限责任公司形式设立的，股东人数应在50人以下，以股份有限公司形式设立的，股东人数不超过200人，且应当有2个以上发起人，其中须半数以上的发起人在中国境内有住所。"
        },
        {
            "title": "股权投资基金已投实缴规模为2亿元，门槛收益率为8%，基金管理人收取20%的超额收益。该基金已完成全部投资，共投资A和B两个公司。2年后，顺利完成A公司的退出，退出后回收现金金额为1.1亿元，并已全额向投资者分配；同时，B公司最近一年净利润为9000万元，最新一轮交易按照息税前利润的6倍进行估值，所得税税率为25%，公司债务余额为1亿元，利息为每年1000万元，交易完成后该股权投资基金占B公司持股比例稀释至20%。按照企业价值/息税前利润倍数法，基金所持有B公司的股权对应估值为（　　）。",
            "question": "A．1.36亿元\nB．1.56亿元\nC．7.8亿元\nD．1.08亿元",
            "answer": "B",
            "explain": "息税前利润(EBIT)=净利润+所得税+利息=0.9+0.9/(1-25%)×25%+0.1=1.3亿元，企业价值(EV)=EBIT×(EV/EBIT倍数)=1.3×6=7.8亿元，则基金所持有B公司的股权对应估值为7.8×20%=1.56亿元。"
        },
        {
            "title": "中国证券投资基金业协会通过网站公示的股权投资基金基本情况不包括（　　）。",
            "question": "A．股权投资基金的备案时间\nB．股权投资基金的基金管理人及基金托管人\nC．股权投资基金的成立时间\nD．股权投资基金的主要投资项目",
            "answer": "D",
            "explain": "中国证券投资基金业协会通过网站公示的股权投资基金基本情况包括：产品名称、产品编码、管理人名称、托管人名称、备案日期、成立日期、到期日、投资类型、是否分级、运作状态。"
        },
        {
            "title": "某股权投资基金实缴5亿元，存续5年，基金清算，不考虑其它税费，可分配金额为10亿元，先还投资者本金，门槛收益率8%（单利），超出门槛收益部分，向管理人分配，直至业绩报酬分配比例达到所有投资者门槛收益与“追赶”金额之和的20%，剩余资金按“二八”分配至基金管理人与投资者。计算基金管理人可分得业绩报酬金额为（　　）。",
            "question": "A．1亿元\nB．0.6亿元\nC．0.8亿元\nD．1.3亿元",
            "answer": "A",
            "explain": "第一步，先还投资者本金5亿，门槛收益率=5×8%×5=2亿，剩余10亿-2亿-5亿=3亿；第二步，向管理人分配，X/(2+X)=0.2，X/2+X=0.2，剩余3亿-0.5亿=2.5亿；第三步，管理人2.5亿×0.2=0.5亿，总计管理人可分得业绩报酬金额=0.5亿+0.5亿=1亿。"
        },
        {
            "title": "股权投资基金进行业务尽职调查的主要目的是（　　）。",
            "question": "A．评估企业资产和业务的合法性及潜在法律风险\nB．了解过去及现在企业的创造价值的机制及变化趋势\nC．关注主要股东与目标公司之间的关联交易是否合法\nD．调查公司及其控股子公司历史财务数据",
            "answer": "B",
            "explain": "业务尽职调查是整个尽职调查工作的核心，目的是了解过去及现在企业创造价值的机制，以及这种机制未来的变化趋势。"
        },
        {
            "title": "李明拟向某股权投资基金进行投资，不得（　　）。",
            "question": "A．签字确认由基金管理人制作的风险提示书\nB．向基金管理人书面确认自己符合合格投资者要求\nC．如实填写风险识别能力和承担能力问卷\nD．向亲朋好友凑集人民币100万元以李明的名义向基金投资，待收益分配时按照各自出资比例分配给各自出资人",
            "answer": "D",
            "explain": "单位或个人不得为规避合格投资者标准，募集以股权投资基金份额或其收益权为标的的金融产品，或者将股权投资基金份额或其收益权进行转让拆分转让，变相突破合格投资者标准。除此情形外，普通投资者主动购买高于其风险承受能力的基金产品或服务的行为，不得突破相关准入资格的限制。"
        },
        {
            "title": "关于折现现金流估值法，以下表述错误的是（　　）。",
            "question": "A．股权自由现金流是可以自由分配给股权拥有者的最低的现金流\nB．企业自由现金流折现模型得到的是企业价值，可以通过价值等式推出股权价值\nC．红利折现模型不适用于红利发放政策不稳定的目标公司\nD．企业自由现金流是指公司在保持正常运营的情况下，可以向出资人（股东和债权人）进行自由分配的现金流",
            "answer": "A",
            "explain": "股权自由现金流是可以自由分配给股权拥有者的最大化的现金流。故“股权自由现金流是可以自由分配给股权拥有者的最低的现金流”是错误的。"
        }, {
            "title": "根据《私募投资基金信息披露管理办法》，信息披露义务人不应向投资者披露的是（　　）。",
            "question": "A．该基金的投资业绩预测\nB．涉及该基金托管业务的重大诉讼、仲裁\nC．该基金的资产负债情况\nD．该基金的招募说明书",
            "answer": "A",
            "explain": "《私募投资基金信息披露管理办法》规定，基金管理人不得进行投资业绩预测。"
        },
        {
            "title": "股权投资基金是否选择托管，通常由（　　）。",
            "question": "A．基金投资者和基金管理人共同约定\nB．基金管理人单独决定\nC．基金销售机构单独决定\nD．基金投资者单独决定",
            "answer": "A",
            "explain": "私募类型的股权投资基金，通常由基金投资者和基金管理人约定是否进行托管。"
        },
        {
            "title": "每个会计年度结束后4个月内，北京某股权投资基金管理人应当向（　　）报送经会计师事务所审计的年度财务报告。",
            "question": "A．北京股权投资基金协会\nB．中国证券投资基金业协会\nC．中国证券业协会\nD．中国证券监督管理委员会",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "普通投资者主动要求购买与之风险承受能力不匹配的基金产品时，以下表述错误的是（　　）。",
            "question": "A．基金募集机构需对普通投资者资格进行审核，若为风险承受能力最低类别投资者需另附说明\nB．普通投资者需对特别警示进行确认，并明确作出愿意自行承担相应不利结果的意思表示\nC．普通投资者需主动向基金募集机构提出申请，并同时申明基金募集机构未在销售过程中主动推介该基金产品或服务的信息\nD．基金募集机构需向普通投资者以纸质或电子文档的方式进行特别警示，告知该产品或服务风险高于投资者承受能力",
            "answer": "A",
            "explain": "“对普通投资者进行审核，若为风险承受能力最低类别投资者需另附说明”该项错误，进行审核，需要确认不属于风险承受能力最低类别投资者及未违反投资者准入规定。普通投资者主动要求购买与之风险承受能力不匹配的基金产品的，基金销售应遵循以下程序：（1）普通投资者主动要求购买；（2）基金募集机构需对普通投资者资格进行审核，若为风险承受能力最低类别投资者需另附说明；（3）基金募集机构需向普通投资者以纸质或电子文档的方式进行特别警示，告知该产品或服务风险高于投资者承受能力；（4）普通投资者需对特别警示进行确认，并明确作出愿意自行承担相应不利结果的意思表示。"
        },
        {
            "title": "关于营业禁止条款，以下说法错误的是（　　）。",
            "question": "A．在实践中，目标公司的创始人股东、高级管理人员以及其他关键人员通常需要签署竞业禁止协议\nB．我国《公司法》明确规定，未经董事会同意，公司董事和高级管理人员不得自营或者为他人经营与所任职同类的业务\nC．竞业禁止条款的目的是保证目标公司的利益不受损害，从而保障投资人的利益\nD．营业禁止主要包括法定营业禁止和约定营业禁止两种形式",
            "answer": "B",
            "explain": "竞业禁止条款是指在投资协议中，股权投资基金为了确保目标公司的良好发展和利益，要求目标公司通过保密协议或其他方式，确保其董事或其他高管不得兼职与本公司业务有竞争的职位，同时，在离职后一段时期内，不得加入与本公司有竞争关系的公司或从事与本公司有竞争的业务。"
        },
        {
            "title": "关于股权投资基金的基金合同，以下表述错误的是（　　）。",
            "question": "A．在投资者签署基金合同之前，募集机构应当向投资者重点揭示基金风险\nB．信息披露义务人应当向投资者披露基金合同的内容\nC．基金合同中可以约定，基金清算过程中对基金合伙人进行基金资产的分配优先于支付基金清算费用\nD．基金合同重大事项发生变更的，基金管理人应按照中国证券投资基金业协会要求及时向中国证券投资基金业协会报告",
            "answer": "C",
            "explain": "基金财产的清算分配顺序有一定的要求，公司型及合伙型股权投资基金在支付清算费用和职工工资、社会保险费用、法定补偿金以及缴纳所欠税款、清偿债务后的剩余财产，向基金投资者进行分配。"
        },
        {
            "title": "关于创业投资的相关概念，表述错误的是（　　）。",
            "question": "A．创业企业，通常指处于创建或重建过程中的成长性企业，包含已经在公开市场上市的企业\nB．创业投资企业不得从事担保业务和房地产业务，但是购买自用房地产除外\nC．经与被投资企业签订投资协议，创业投资企业可以以股权和优先股、可转换优先股等准股权方式对未上市企业进行投资\nD．创业投资，系指向创业企业进行股权投资，以期所投资创业企业发育成熟或相对成熟后主要通过股权转让获得资本增值收益的投资方式",
            "answer": "A",
            "explain": "创业投资，是指向处于各个创业阶段的未上市成长性企业进行的股权投资。"
        },
        {
            "title": "某有限合伙型创业投资企业采用以下方式投资，其中可以享受《国家税务总局关于有限合伙制创业投资企业法人合伙人企业所得税公告》中所规定的优惠政策的是（　　）。",
            "question": "A．采用股权投资的方式投资于未上市的中小高新技术企业\nB．采用股权投资的方式投资于已上市的中小高新技术企业\nC．采用债权投资的方式投资于未上市的中小高新技术企业\nD．采用债权投资的方式投资于已上市的中小高新技术企业",
            "answer": "A",
            "explain": ""
        }, {
            "title": "关于股权投资母基金，以下表述错误的是（　　）。",
            "question": "A．为缺乏投资经验的投资者提供了投资股权投资基金的渠道\nB．既可以投资于其他管理人管理的基金，又可以直接参与到单项投资项目，较为灵活\nC．通常投资于多只股权投资基金，从而避免投资中依赖单一基金管理人的风险\nD．可帮助投资者投资小规模的基金实现分散投资，但无法帮助中小投资者配置大型基金",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "在我国募集股权投资基金，可以使用（　　）。",
            "question": "A．公开方式募集和非公开方式募集\nB．非公开方式募集\nC．半封闭式募集\nD．公开方式募集",
            "answer": "B",
            "explain": "在我国，目前股权投资基金尚只能以非公开方式募集。"
        },
        {
            "title": "运用清算价值法进行企业估值时，不属于通常采取的步骤是（　　）。",
            "question": "A．计算并确定折扣率\nB．选择与目标企业较为接近的上市公司作为参考\nC．将企业分拆成可供出售的几个业务或资产包\nD．估算单个业务或资产包的变现价值",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "股权投资基金甲对目标公司A进行初步尽职调查后判断该公司具有较高投资价值，并计划独家完成对A公司的投资，为了避免在尽职调查谈判期间A公司再与其他投资机构接触，基金甲可考虑在投资框架协议中加入的条款是（　　）。",
            "question": "A．优先认购权条款\nB．保护性条款\nC．第一拒绝权条款\nD．排他性条款",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "以下股权投资基金的行为中，属于我国刑法规定的非法经营行为（　　）。",
            "questions": "I．未经国家有关主管部门批准，经营证券资产管理业务<br>II．未经国家有关主管部门批准，从事资金支付结算业务<br>III．未经国家有关主管部门批准，向某家初创企业同时给予股权投资和债权融资<br>IV．未经国家有关主管部门批准，投资风格倾向于低风险、低收益，在实际业务中以贷款业务为主业，以利息收入为主要利润来源",
            "question": "A．I、III\nB．II、III、IV\nC．I、II、III、IV\nD．I、II、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "随售权条款通常与（　　）条款同时出现。",
            "question": "A．第一拒绝权\nB．反摊薄\nC．拖售权\nD．优先认购权",
            "answer": "A",
            "explain": "随售权又称共同出售权，是指目标公司的其他股东欲对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。随售权条款通常与第一拒绝权条款同时出现。"
        },
        {
            "title": "股权投资基金A投资于从事人工智能的早期创业项目B公司，预计4年后退出时B公司的股权价值为100亿元，基金A的目标收益率为60%，预计本次投资后至基金A退出时，B公司还会进行一轮融资，此轮融资将稀释基金A在B公司的初始股份，稀释比例为20%，若基金A本次投资额为1亿元，则B公司在投资时点的估值为（　　）亿元，基金A退出时收回款项（　　）亿元，基金A初始投资时所持有的B公司股份比例为（　　），A公司退出时所持有的B公司股份比例为（　　）。",
            "question": "A．13.8,5.80,7.25%,5.80%\nB．15.3,5.24,6.54%,5.24%\nC．16.5,4.85,6.06%,4.85%\nD．12.2,6.55,8.19%,6.55%",
            "answer": "B",
            "explain": ""
        }, {
            "title": "信托（契约）型股权投资基金的份额转让过程中，（　　）同意后，即可按照基金合同的约定办理转让手续。",
            "questions": "I．出让方\nII．受让方\nIII．基金管理人\nIV．其他基金投资者",
            "question": "A．III\nB．I、II\nC．I、II、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": "基金份额的转让涉及出让方、受让方及基金管理人，三方协商同意即可按照基金合同的约定办理转让手续，无须征得其他基金投资者的同意。"
        },
        {
            "title": "以下对股权投资基金估值方法中的成本法的描述，不正确的是（　　）。",
            "question": "A．成本法包括账面价值法和重置成本法\nB．重置成本法是用待评估资产的完全重置成本（重置全价）减去其各种贬值后的差额作为该项资产价值的评估方法\nC．公司总资产减去总负债后的净值即为公司的账面价值\nD． 账面价值法的主观因素较大",
            "answer": "D",
            "explain": "成本法包括账面价值法和重置成本法，公司总资产减去总负债后的净值即为公司的账面价值。重置成本法是用待评估资产的完全重置成本减去各种贬值后的差额作为该项资产价值的评估方法。"
        },
        {
            "title": "A公司为在中国证券投资基金业协会登记的管理人，管理乙股权投资基金，不符合乙基金潜在投资人条件的是（　　）。",
            "question": "A．已在中国证券投资基金业协会备案成为私募基金的有限合伙企业，拟对Z基金投资120万元\nB．具有相应的风险识别能力和风险承担能力且净资产为1000万元的有限责任公司，拟对Z基金投资120万元\nC．A公司负责管理该支基金的从业人员张某，近三年个人年均收入约25万元，拟对Z基金投资80万元\nD． 拥有一套价值约1000万元的房产及200万元的银行存款的退休人员李某，拟对乙基金投资120万元",
            "answer": "D",
            "explain": "股权投资基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只基金的金额不低于100万元且符合下列相关标准的单位和个人：(1)净资产不低于1000万元的单位；(2)金融资产不低于300万元或者最近三年年均收入不低于50万元的个人。金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。"
        },
        {
            "title": "某合伙型股权投资基金，在基金合同中约定采取瀑布式的收益分配体系，在基金进行清算时，分配顺序排在最后的是（　　）。",
            "question": "A．清算费用\nB．应付律师咨询服务费\nC．基金投资者的本金\nD． 应付职工法定补偿金",
            "answer": "C",
            "explain": "公司型及合伙型股权投资基金在支付清算费用和职工工资、社会保险费用、法定补偿金以及缴纳所欠税款、清偿债务后的剩余财产，向基金投资者进行分配。"
        },
        {
            "title": "关于股权投资基金的投资后管理增值服务，以下表述正确的是（　　）。",
            "question": "A．基金协助被投资企业进行后续再融资工作，只有被投资企业完成了后续融资，被投资企业的价值提升才能体现\nB．对于处在不同成长阶段的被投资企业，基金对其在投资后管理中参与的程度和侧重点基本一致\nC．增值服务的目的主要是完善公司治理结构，满足公司上市要求，最终在公司IPO后实现退出\nD． 增值服务一方面可以协助被投资企业更好的发展，另一方面也可以有效降低投资风险",
            "answer": "D",
            "explain": "在当前市场环境下，增值服务能力甚至成为投资机构的核心竞争力。一方面，通过增值服务能协助被投资企业实现更好更快的发展；另一方面，增值服务也可以有效降低投资风险。"
        },
        {
            "title": "关于中国企业境外直接上市，以下表述错误的是（　　）。",
            "question": "A．我国企业境外直接上市，可获得外汇资金\nB．境外直接上市的优点在于可直接进入境外资本市场，提升企业国际知名度和影响力\nC．我国企业境外直接上市，需要向中国证监会提出申请\nD． 我国企业境外直接上市也包括通过境外特殊目的公司的名义申请境外交易所上市交易的方式",
            "answer": "D",
            "explain": "境外上市分为境外直接上市和境外间接上市两种方式。境外直接上市的优点在于可直接进入境外资本市场，节省信息传递成本，极大地提升企业国际知名度和影响力，并获得外汇资金。我国企业选择境外直接上市，需首先向中国证监会提出申请。境外间接上市是指境内公司将境外上市作为目标，通过在境外设立特殊目的公司（SPV）的方式，实现境外上市。"
        }, {
            "title": "与企业价值正相关的企业经营指标包括（　　）。",
            "questions": "I．收入\nII．利润\nIII．增长率\nIV．负债率",
            "question": "A．I、II\nB．II、III、IV\nC．I、II、III\nD．I、III、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的募集流程，以下表述错误的是（　　）。",
            "question": "A．在投资者签署基金合同前，募集机构应与投资者签署风险揭示书\nB．募集机构或相关合同约定的责任主体应开立股权投资基金募集结算资金专用账户\nC．对于已完成特定对象确定程序的投资者，如果该投资者风险承担能力发生重大变化时，可主动申请对自身风险承担能力进行重新评估\nD． 在进行特定对象确定程序，投资者填写风险调查问卷前，募集机构应先向投资者介绍基金及基金管理人的具体情况",
            "answer": "D",
            "explain": "在投资者签署基金合同前，募集机构应与投资者签署风险揭示书，募集机构或相关合同约定的责任主体应开立股权投资基金募集结算资金专用账户，对于已完成特定对象确定程序的投资者，如果该投资者风险承担能力发生重大变化时，可主动申请对自身风险承担能力进行重新评估。"
        },
        {
            "title": "关于排他性条款，以下表述错误的是（　　）。",
            "question": "A．排他性条款设立后，投资方必须保证在排他期结束后投资目标公司\nB．投资双方签署该条款后，目标公司在排他期内不得再与其他投资方接触\nC．排他性条款的设立主要是为了保障股权投资基金与目标公司双方的时间和经济效率\nD． 排他性条款中规定的排他期可以提前结束",
            "answer": "A",
            "explain": "排他性条款设立后，投资方可以不在排他期结束后投资目标公司。"
        },
        {
            "title": "关于股权投资基金募集，以下表述错误的是（　　）。",
            "question": "A．管理人可自行拟定基金募集推荐材料并寻找投资者\nB．募集过程中必须对投资者的风险识别能力和风险承担能力进行评估\nC．股权投资基金可以选择公开募集或非公开募集两种方式\nD． 基金管理人委托第三方代销机构募集时，需确保该代销机构获得中国证监会基金销售业务资格且成为中国证券投资基金业协会会员",
            "answer": "C",
            "explain": "在我国，股权投资基金尚只能以非公开方式募集。"
        },
        {
            "title": "关于股权投资基金的特点，以下表述错误的是（　　）。",
            "question": "A．流动性较好\nB．投资后管理投入资源较多\nC．投资期限长\nD． 专业性较强",
            "answer": "A",
            "explain": "股权投资基金具有以下特点：投资期限长、流动性较差、投资后管理投入资源较多，专业性较强，收益波动率较高。"
        },
        {
            "title": "有限合伙型股权投资基金的纳税义务人是（　　）。",
            "question": "A．全体合伙人\nB．合伙企业\nC．有限合伙人\nD． 普通合伙人",
            "answer": "A",
            "explain": "根据《合伙企业法》等相关规定，合伙企业生产经营所得和其他所得采取“先分后税”的原则：合伙企业以每一个合伙人为纳税义务人，合伙企业层面不缴纳所得税。合伙企业合伙人是自然人的，缴纳个人所得税；合伙人是法人和其他组织的，缴纳企业所得税。"
        }, {
            "title": "关于并购基金，以下表述错误的是（　　）。",
            "question": "A．并购基金通常在收购中会产生协同效应\nB．并购基金是财务投资者\nC．并购基金是一种所有权转移的投资方式\nD．并购基金主要是杠杆收购基金",
            "answer": "A",
            "explain": "并购基金通过购买股权的形式对企业的存量股权进行投资，并不为企业提供任何资金，只是一种所有权转移的投资方式，获得资金的是出让企业股权的老股东。并购基金作为财务投资者，在收购中不会产生协同效应。与之相对应，战略投资者往往能够从收购中获得协同效应。从这个角度看，战略投资者往往支付比并购基金更高的收购价格。并购基金之所以能够与战略投资者在收购中竞价，主要是因为其在收购通常采取更高的杠杆率。因此，并购基金主要是杠杆收购基金。"
        },
        {
            "title": "某股权投资基金A拟向合格投资者募集四亿元资金投资于B公司，B公司管理层预期投资当年的净利润不低于1.5亿元，B公司的企业所得税为25%，利息每年2000万元，拟采用相对估值法对B公司进行估值。关于企业估值的特点，以下表述错误的是（　　）。",
            "question": "A．部分只有在整体中才能体现出其价值\nB．整体价值来源于要素的结合方式\nC．整体价值只有在运行中才能体现出来\nD．整体是各部分的简单相加",
            "answer": "D",
            "explain": "企业作为整体虽然是由各部分组成的，但是它并不是各部分的简单相加，而是有机的结合。"
        },
        {
            "title": "使用相对估值法对目标企业进行估值，挑选可比公司的原则通常不包括（　　）。",
            "question": "A．使用同一会计准则\nB．市场环境与风险度接近\nC．公司规模相近\nD．所处行业与主营业务/主导产品相同或相近",
            "answer": "A",
            "explain": "可比公司是指与目标公司所处的行业、公司的主营业务或主导产品、公司规模、盈利能力、资本结构、市场环境以及风险度等方面相同或相近的公司。在实际估值中，选取可比公司时，一般先根据一定条件初步挑选可比公司，然后将初步挑选的可比公司分为两类：最可比公司类"
        },
        {
            "title": "关于投资协议中的常见条款，以下表述正确的是（　　）。",
            "question": "A．保护性条款设置的目标，通常是防止创始人因企业经营经验不足导致经营决策失误\nB．完全剩轮条款的相关计算同时考虑了后轮融资的价格和额度，相较加权平均条款可以更大限度的保护前轮投资者的利益\nC．估值调整条款通常包括现金补偿或股份补充机制，回售权条款也可用以实现估值调整的目的\nD．债售权条款保障股权投资基金若计划退出，符合约定的条件时，创始人需按照基金和第三方并购方式达成的条件完成股权转让",
            "answer": "C",
            "explain": "估值调整条款通常包括现金补偿或股份补充机制，回售权条款也可用以实现估值调整的目的。"
        },
        {
            "title": "公司型、合伙型和信托(契约)型股权投资基金中，投资者拥有权力最大的是（　　），可能产生所得税双重征税的是（　　），无需办理工商登记手续的是（　　）。",
            "question": "A．公司型、公司型、信托型\nB．公司型、有限合伙型、信托型\nC．有限合伙型、公司型、信托型\nD．信托型、公司型、有限合伙型",
            "answer": "A",
            "explain": "公司型基金的投资者既是基金份额持有人又是公司股东，行使相应权利、承担相应义务和责任，合伙型基金的有限合伙人不参与投资决策，信托型基金投资人也不参与投资决策，故投资者拥有权力最大的是“公司型基金”。有限合伙企业并不是独立的法人，不能独立于合伙人承担民事责任，因此可能产生所得税双重征税的是“公司型基金”。信托型基金无需办理工商登记手续。"
        },
        {
            "title": "关于公司型股权投资基金基本设立流程，以下表述正确的是（　　）。",
            "question": "A．办理工商税务等相关登记→在中国证券投资基金业协会备案→办理注册地址合格证明\nB．办理工商税务等相关登记→办理注册地址合格证明→在中国证券投资基金业协会备案\nC．工商名称预先核准申请→在中国证券投资基金业协会备案→办理注册地址合格证明→办理工商税务等相关登记\nD．工商名称预先核准申请→办理设立登记事宜→领取营业执照→在中国证券投资基金业协会备案",
            "answer": "D",
            "explain": "公司型基金设立的流程是工商名称预先核准申请→办理设立登记事宜→领取营业执照→在中国证券投资基金业协会备案。"
        }, {
            "title": "股权投资实践中，随售权往往涉及锁定期的规定，通常情况下，对于持股锁定期的表述正确的是（　　）。",
            "questions": "I．锁定的对象是创始人股东的股份\nII．锁定的对象是财务投资者股东的股份\nIII．其他股东同意的情况下锁定期可以被豁免\nIV．其他股东同意的情况下锁定期也不能被豁免",
            "question": "A．II、III\nB．II、IV\nC．I、III\nD．I、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于股权投资基金参与被投资企业的公司治理，以下表述错误的是（　　）。",
            "question": "A．直接参与被投资企业股东(大)会、董事会和监事会\nB．行使优先股或债券的转换权利，增加在股东大会或董事会的话语权，从而实施更有力的监控\nC．定期对被投资企业进行内部和外部访谈\nD． 根据投资协议约定的保护性条款，对可能损害投资机构权益的决策行使一票否决权",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于尽职调查的具体环节，以下表述错误的是（　　）。",
            "question": "A．企业现场调研指对目标公司进行内部与外部访谈，目的是获取实地考察目标公司经营现场之外的第二手资料\nB．制定详尽的尽职调查计划有利于基金管理人内部工作安排，也有利于目标企业更好地配合尽职调查工作\nC．内部复核指基金管理人作为内部自我监督的可能程序，对尽职调查报告等材料进行复核\nD． 资料收集与研读指基金管理人按照尽职调查的目的收集、整理各类相关资料，并进行适当处理和研判",
            "answer": "A",
            "explain": "二手资料与项目信息的研读、行业前景的调查，都仅停留在“纸上谈兵”的阶段。要获得目标公司的第一手资料，"
        },
        {
            "title": "股权投资基金信息披露义务人披露基金信息时，不得存在以下哪项行为（　　）。",
            "question": "A．描述投资组合运营情况\nB．登载行业组织密级或吹性文字\nC．披露基金净值等财务指标\nD． 披露基金收益分配和损失承担情况",
            "answer": "B",
            "explain": "不得登载任何自然人、法人或者其他组织的祝贺性、恭维性或者推荐性文字。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/smgq-2.js